var exports = {
  "areaChartLabel": "areaChartLabel-X01OQ",
  "left": "left-X01OQ",
  "right": "right-X01OQ",
  "legend": "legend-X01OQ",
  "areaChartTooltipLabel": "areaChartTooltipLabel-X01OQ",
};

__webpack_require__.r(module.exports = exports);
